export const marketHolidays = [
    { "date": "2025-02-26", "description": "Mahashivratri" },
    { "date": "2025-03-14", "description": "Holi" },
    { "date": "2025-03-31", "description": "Id-Ul-Fitr (Ramadan Eid)" },
    { "date": "2025-04-10", "description": "Shri Mahavir Jayanti" },
    { "date": "2025-04-14", "description": "Dr. Baba Saheb Ambedkar Jayanti" },
    { "date": "2025-04-18", "description": "Good Friday" },
    { "date": "2025-05-01", "description": "Maharashtra Day" },
    { "date": "2025-08-15", "description": "Independence Day" },
    { "date": "2025-08-27", "description": "Ganesh Chaturthi" },
    { "date": "2025-10-02", "description": "Mahatma Gandhi Jayanti/Dussehra" },
    { "date": "2025-10-21", "description": "Diwali Laxmi Pujan" },
    { "date": "2025-10-22", "description": "Diwali-Balipratipada" },
    { "date": "2025-11-05", "description": "Prakash Gurpurb Sri Guru Nanak Dev" },
    { "date": "2025-12-25", "description": "Christmas" }
  ];
  